module.exports = __webpack_public_path__ + "img/reset-password-desktop-en.b12e8838.jpg";